import { Award, Sparkles, MessageCircle, Printer } from "lucide-react";
import { KidAvatar } from "@/components/live/KidAvatar";

const Section = ({ title, icon: Icon, children, testId }) => (
  <section className="rounded-3xl bg-white/80 border border-[#E6DEC3] p-6" data-testid={testId}>
    <p className="text-xs uppercase tracking-widest text-stone-500 inline-flex items-center gap-1.5"><Icon className="w-3.5 h-3.5" /> {title}</p>
    <div className="mt-3">{children}</div>
  </section>
);

export const MemoryBook = ({ m }) => (
  <div className="rise" data-testid="memory-book">
    <div className="rounded-[2rem] bg-[#2C4A3E] text-[#F7F3EB] p-8 flex flex-wrap items-center gap-6">
      <KidAvatar a={m.avatar} className="w-24 h-24" testId="memory-avatar" />
      <div className="flex-1 min-w-[220px]">
        <span className="text-xs uppercase tracking-[0.25em] text-[#F2D49B]">Class Memory Book · {new Date(m.class.starts_at).toLocaleDateString([], { month: "long", day: "numeric", year: "numeric" })}</span>
        <h1 className="font-display text-3xl sm:text-4xl mt-2" data-testid="memory-topic">{m.class.topic}</h1>
        <p className="text-sm mt-1 opacity-80">{m.kid_name} · {m.class.grade_label} · {m.class.subject}</p>
      </div>
      <div className="rounded-2xl bg-[#F2D49B] text-[#5B3A1E] px-5 py-4 text-center" data-testid="memory-badge" data-badge={m.badge.id}>
        <Award className="w-8 h-8 mx-auto" /><p className="font-display text-lg mt-1">{m.badge.name}</p><p className="text-xs max-w-[180px]">{m.badge.note}</p>
      </div>
    </div>
    <div className="grid md:grid-cols-2 gap-6 mt-6">
      <Section title="What I shared" icon={MessageCircle} testId="memory-shared">
        {m.shared.length ? <ul className="space-y-2">{m.shared.map((t, i) => <li key={i} className="rounded-2xl bg-[#F7F3EB] px-4 py-2 text-sm">“{t}”</li>)}</ul>
          : <p className="text-sm text-stone-600">You listened mindfully today. Listening is a gift to the group.</p>}
        {(m.reactions.length > 0 || m.hands > 0) && <p className="text-sm mt-3 text-stone-600">{m.reactions.join(" ")} {m.hands > 0 && `· raised hand ${m.hands}x`}</p>}
      </Section>
      <Section title="Our group's big ideas" icon={Sparkles} testId="memory-ideas">
        <p className="text-sm text-stone-700" data-testid="memory-summary">{m.summary}</p>
        <ul className="mt-3 space-y-2">{m.ideas.map((t, i) => <li key={i} className="text-sm pl-4 border-l-2 border-[#C87D53]">{t}</li>)}</ul>
      </Section>
    </div>
    <button onClick={() => window.print()} data-testid="memory-print-btn" className="mt-6 inline-flex items-center gap-2 px-5 py-2.5 rounded-full border border-[#E6DEC3] text-sm hover:bg-[#F1EADB] transition-colors"><Printer className="w-4 h-4" /> Print keepsake</button>
  </div>
);
